const formatName = (name: string) =>
  encodeURIComponent(name)
    .replace(/(%2B)+/g, '+')
    .replace(/(%2C)+/g, '+');

export default formatName;
